// Client to Host
export const LAUNCH_IFRAME = 'launch-iframe'
export const CLOSE_IFRAME = 'close-iframe'
export const GET_WEBSOCKET = 'get-websocket'
export const GET_WEBSOCKET_READY_STATE = 'get-websocket-ready-state'
export const SEND_WEBSOCKET_MESSAGE = 'websocket-message'
export const SET_DIMENSIONS = 'set-dimensions'
export const REMOVE_WEBSOCKET = 'remove-websocket'
export const OPEN_SIMPLE_LINK = 'open_simple_link'

// Host to Client
export const INITIATE_CLOSING = 'close_initiated'
export const CLOSE = 'close'
